import { PasswordResetForm } from "@/components/auth/password-reset-form";
import { MoonStar } from "lucide-react";

export default function PasswordResetPage() {
  return (
    <div className="flex min-h-screen w-full flex-col items-center justify-center bg-background p-4">
      <div className="w-full max-w-md">
        <div className="flex flex-col items-center gap-4 text-center mb-8">
            <MoonStar className="h-10 w-10 text-primary" />
            <h1 className="text-4xl font-bold text-foreground">
              Reset Your Password
            </h1>
            <p className="text-muted-foreground">
              Enter your email to receive a password reset link.
            </p>
        </div>
        <PasswordResetForm />
      </div>
    </div>
  );
}
